module.exports = __webpack_public_path__ + "static/media/artist_07.858a591d.png";